module.exports = __webpack_public_path__ + "media/images/gallery/constellations/aquarius/aqr_dir-daac5314291a9f3d71f0ea5a5a76758b.gif";